
const TYPES = {
    TOAST: 'toast',
    ALERT: 'alert',
    CONFIRM: 'confirm',
    TIP: 'tip'
};

const THEMES = () => {
    return {
        success: TB.config('color.green'),
        danger: TB.config('color.red'),
        warning: TB.config('color.orange'),
        info: TB.config('color.blue')
    }
};


export default {THEMES, TYPES}
